import checkStatus from '../utils/checkStatus';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from './JwtStore'

export default {
  fetchHotNow() {
    return fetch(api('home/hot-now'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.HOME_STORE_FETCH_HOT_NOW_COMPLETED,
        home: response.data,
      }))
      .catch(dispatchHttpError);
  },

  fetchToComplete() {
    return fetch(api('home/to-complete'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.HOME_STORE_FETCH_TO_COMPLETE_COMPLETED,
        home: response.data,
      }))
      .catch(dispatchHttpError);
  },

  fetchNeverSeen() {
    return fetch(api('home/never-seen'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.HOME_STORE_FETCH_NEVER_SEEN_COMPLETED,
        home: response.data,
      }))
      .catch(dispatchHttpError);
  }
}
